module.exports = __webpack_public_path__ + "img/point_incomplete.5e818931.svg";